import { LocalData } from "../General/LocalData";
import { collection, getDocs, getFirestore, query, where } from "firebase/firestore";
import { SurveyData } from "./SurveyData";
import { UnitData } from "../Property/Units/UnitData";
import { SurveyAnswerData } from "./SurveyAnswerData";

export class SurveysLoader {
  loadingReports = false;
  loadedReports = false;
  loadedListeners: (() => void)[] = [];

  reportsAdministrating: SurveyData[] = [];
  reportsAnswered: SurveyToAnswerData[] = [];
  reportsNotAnswered: SurveyToAnswerData[] = [];

  loadReports(loadedListener: () => void) {
    const db = getFirestore();
    const reportsRef = collection(db, "reports");

    this.loadedListeners.push(loadedListener);
    if (!this.loadingReports) {
      this.loadingReports = true;

      let landlordProperties: string[][] = [[]];
      let units: string[][] = [[]];

      LocalData.currentUser.memberDatas.forEach((member) => {
        if (member.hasLandlord()) {
          if (landlordProperties[landlordProperties.length - 1].length >= 10) {
            landlordProperties.push([member.property.id]);
          } else {
            landlordProperties[landlordProperties.length - 1].push(member.property.id);
          }
        }
        if (member.hasTenant()) {
          for (let unit of member.units) {
            if (units[units.length - 1].length >= 10) {
              units.push([unit.id]);
            } else {
              units[units.length - 1].push(unit.id);
            }
          }
        }
      });

      if (landlordProperties.length === 1 && landlordProperties[0].length === 0) {
        landlordProperties.pop();
      }
      if (units.length === 1 && units[0].length === 0) {
        units.pop();
      }

      let totalLoadCount = landlordProperties.length + units.length + 1;
      let loadedCount = 0;

      landlordProperties.forEach((landlordArray) => {
        if (landlordArray.length === 0) return;
        const filteredQuery = query(reportsRef, where("allProperties", "array-contains-any", landlordArray));

        getDocs(filteredQuery)
          .then((snapshot) => {
            snapshot.docs.forEach((document) => {
              const data = document.data();
              const report = LocalData.surveys.addData(document.id);
              report.setup(data);
            });
          })
          .finally(() => {
            loadedCount++;
            if (loadedCount >= totalLoadCount) {
              this.loadAnswers();
            }
          });
      });
      units.forEach((unitArray) => {
        if (unitArray.length === 0) return;
        const filteredQuery = query(reportsRef, where("allUnits", "array-contains-any", unitArray), where("isDraft", "==", false));

        if (unitArray.length > 0) {
          getDocs(filteredQuery)
            .then((snapshot) => {
              snapshot.docs.forEach((document) => {
                const data = document.data();
                const report = LocalData.surveys.addData(document.id);
                report.setup(data);
              });
            })
            .catch((error) => {
              console.log("Error loading reports", error);
            })
            .finally(() => {
              loadedCount++;
              if (loadedCount >= totalLoadCount) {
                this.loadAnswers();
              }
            });
        } else {
          loadedCount++;
          if (loadedCount >= totalLoadCount) {
            this.loadAnswers();
          }
        }
      });

      const filteredQuery = query(reportsRef, where("createdBy.userID", "==", LocalData.currentUser.id));
      getDocs(filteredQuery)
        .then((snapshot) => {
          snapshot.docs.forEach((document) => {
            const data = document.data();
            const report = LocalData.surveys.addData(document.id);
            report.setup(data);
          });
        })
        .catch((error) => {
          console.log("Error loading reports", error);
        })
        .finally(() => {
          loadedCount++;
          if (loadedCount >= totalLoadCount) {
            this.loadAnswers();
          }
        });
    }
  }

  loadAnswers() {
    console.log("Loaded all reports");
    this.loadingReports = false;
    this.loadedReports = true;

    let totalToLoad = LocalData.surveys.size();
    let totalLoaded = 0;

    LocalData.surveys.documents.forEach((report) => {
      report.loadAnswers(() => {
        totalLoaded++;
        if (totalLoaded >= totalToLoad) {
          this.filterReports();
        }
      });
    });
    if (totalToLoad === 0) {
      this.filterReports();
    }
  }

  filterReports() {
    console.log("Filtering reports");
    this.reportsAdministrating = [];
    this.reportsAnswered = [];
    this.reportsNotAnswered = [];

    LocalData.surveys.documents.forEach((report) => {
      if (report.createdBy?.user === LocalData.currentUser) {
        this.reportsAdministrating.push(report);
      }
      LocalData.currentUser.memberDatas.forEach((member) => {
        if (member.hasLandlord()) {
          if (report.allProperties.indexOf(member.property) !== -1 && this.reportsAdministrating.indexOf(report) === -1) {
            this.reportsAdministrating.push(report);
          }
        }
        if (member.hasTenant()) {
          for (let unit of member.units) {
            if (report.allUnits.indexOf(unit) !== -1) {
              let hasAnswered = false;
              for (let answer of report.answers) {
                if (answer.isReportedByUserUnit()) {
                  this.reportsAnswered.push(new SurveyToAnswerData(report, unit, answer));
                  hasAnswered = true;
                }
              }
              if (!hasAnswered) {
                this.reportsNotAnswered.push(new SurveyToAnswerData(report, unit, undefined));
              }
            }
          }
        }
      });
    });
    for (let listener of this.loadedListeners) {
      listener();
    }
  }
}

export class SurveyToAnswerData {
  report: SurveyData;
  unit: UnitData;
  answer?: SurveyAnswerData;
  constructor(report: SurveyData, unit: UnitData, answer: SurveyAnswerData | undefined) {
    this.report = report;
    this.unit = unit;
    this.answer = answer;
  }
}
